<div clickOutside (onClickOutside)="closeDropdown()">
  <div
    class="flex cursor-pointer items-center rounded-xl border border-neutral-200 bg-white px-3 py-4"
    (click)="toggleActive()">
    <span style="-webkit-line-clamp: 1; word-break: break-all" class="max-one-line">
      {{ display() }}
    </span>
    <app-icon name="chevron-down" class="ml-auto" fontSize="20" />
  </div>
  <div
    class="absolute top-[calc(100%+.5rem)] z-20 hidden w-full rounded-xl border bg-white py-2 md:block"
    *ngIf="isActive()">
    <div class="flex max-h-52 flex-col overflow-y-auto">
      <div
        *ngIf="searchable"
        class="prose-text-sm mx-4 mb-5 flex items-center gap-2.5 rounded-[80px] border border-neutral-200 bg-neutral-100 p-3 text-neutral-700">
        <app-icon name="search" />
        <input
          type="text"
          [placeholder]="placeholder"
          class="prose-text-sm w-0 flex-1 border-none bg-inherit p-0 outline-none placeholder:text-neutral-500 focus:ring-0"
          (keyup)="updateQuery($event)" />
      </div>
      <div *ngFor="let option of filteredOptions()">
        <div
          class="flex cursor-pointer items-center bg-white px-4 py-2 hover:bg-neutral-200"
          (click)="select(option)">
          <span>
            {{ option.label }}
          </span>
          <img
            [src]="
              isSelected(option)
                ? 'assets/images/icons/checked.svg'
                : 'assets/images/icons/unchecked.svg'
            "
            alt=""
            class="ml-auto" />
        </div>
      </div>
    </div>
  </div>
</div>
